import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { IHotelConfiguration as IHC } from "@/@types/_shared/configuration/hotel-configuration";
import { languages as defaultLanguages } from "@/config/languags.config.json";
import { ICurrency } from "@/@types/currency";

const state: IHC = {
  _id: "",
  name: "",
  languages: defaultLanguages,
  currensy: [],
  ip: "",
  zit: true,
  auto: {
    routeInfo: true,
  },
};

const mutations: MutationTree<IHC> = {
  SET_HOTEL_CONFIG: (state: IHC, payload: IHC) => {
    state = payload;
  },
  CHANGE_ID: (state: IHC, payload: string) => {
    state._id = payload;
  },
  CHANGE_AUTO: (state: IHC, payload: { code: string; auto: boolean }) => {
    state.auto[payload.code] = payload.auto;
  },
  CHANGE_LANGUAGES: (state: IHC, payload: Array<string>) => {
    state.languages = payload.length ? payload : defaultLanguages;
  },
  CHANGE_CURENSY: (state: IHC, payload: Array<ICurrency>) => {
    state.currensy = payload;
  },
  CHANGE_ZIT_STATUS: (state: IHC, zit: boolean) => {
    state.zit = zit;
  },
};
const actions: ActionTree<IHC, IRootState> = {
  setHotelConfig({ commit }, payload: string) {
    commit("SET_HOTEL_CONFIG", payload);
  },
  changeAuto({ commit }, payload: { code: string; auto: boolean }) {
    commit("CHANGE_AUTO", payload);
  },
  changeID({ commit }, payload: string) {
    commit("CHANGE_ID", payload);
  },
  changeLanguages({ commit }, payload: Array<string>) {
    commit("CHANGE_LANGUAGES", payload);
  },
  setCurensy({ commit }, payload: Array<string>) {
    commit("CHANGE_CURENSY", payload);
  },
  set_zit_status({ commit }, zit: boolean) {
    commit("CHANGE_ZIT_STATUS", zit);
  },
};
const getters: GetterTree<IHC, IRootState> = {
  getHotelConfig(state: IHC) {
    return state;
  },
  getHotelName(state: IHC) {
    return state.name;
  },
  getHotelID(state: IHC) {
    return state._id;
  },
  getCurensy(state: IHC) {
    return state.currensy;
  },
  getAutoConfig(state: IHC) {
    return state.auto;
  },
  getLanguages(state: IHC) {
    return state.languages;
  },
  zit(state: IHC) {
    return state.zit;
  },
};

export const hotelConfig: Module<IHC, IRootState> = {
  state,
  mutations,
  actions,
  getters,
};
